import { render, staticRenderFns } from "./Estadisticas.vue?vue&type=template&id=50200903&"
import script from "./Estadisticas.vue?vue&type=script&lang=js&"
export * from "./Estadisticas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports